module.exports = __webpack_public_path__ + "static/SuisseIntl-SemiBold-ed6c026cfee1ea821de14af99b61aada.woff2";